import { Component, Input, OnInit } from '@angular/core';
import { ILabels } from "../../interfaces/ILabels";
import { Yii } from "../../interfaces/Yii";
import { IGetBookingsAirResponse } from "../../service/resources/booking/interfaces/IGetBookings";
import {DateService} from "../../date/date.service";

@Component({
  selector: 'issue-status',
  template: `
    <label *ngIf="issueStatus">
      {{ wording.issueStatus }} <strong [class]="issueStatusClass">{{ issueStatus }}</strong>
    </label>
  `,
  styles: [
  ]
})
export class IssueStatusComponent implements OnInit {
  @Input()
  public booking: IGetBookingsAirResponse;
  public wording: ILabels = {
    issueStatus: Yii.t("wui-shared-js", "Statut d'émission : "),
  };
  public issueStatus: string;
  public issueStatusClass: string[] = [];

  constructor(private readonly dateService: DateService) { }

  public ngOnInit(): void {
    this.initIssueStatus();
    if (this.issueStatus) {
      this.initIssueStatusClass();
    }
  }

  private initIssueStatus(): void {
    this.issueStatus = this.booking?.issueStatus;
  }

  private initIssueStatusClass(): void {
    if (this.booking.whenToIssue) {
      const now: Date = this.dateService.getStr2JsDate(new Date().toString());
      const whenToIssue: Date = this.dateService.getStr2JsDate(this.booking.whenToIssue);
      if (now.toString() === whenToIssue.toString()) {
        this.issueStatusClass.push('warning');
      } else if (now > whenToIssue) {
        this.issueStatusClass.push('error');
      }
    }
  }

}
